require('leaflet');
function marker(mapa, latitude, longitude, texto) {
    var macador = L.marker([latitude, longitude]).addTo(mapa);
    if(texto) {
        macador.bindPopup(texto).openPopup();
    }

}
function init(idDiv, latitude, longitude) {
    var osmUrl='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';


    var map = L.map(idDiv).setView([latitude, longitude], 13);
    L.tileLayer(osmUrl, {minZoom: 1, maxZoom: 20}).addTo(map);

    return map;

}

export default {
    init,
    marker
}


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/mapa.js